export const VossDiscountType = {
    FlatPrice: 0,
    Percentage: 1
}